module.exports = __webpack_public_path__ + "img/checked-square.3f47e4ff.svg";